var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","justify-center":""}},[_c('div',{staticClass:"pt-8 mt-6 not-found"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("No content found")]),_c('p',[_vm._v("Please stick to the rivers and the lakes that you're used to.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }